import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditSessionPayload } from '@app-store/slices/sessions/editSession'

interface TaskAction extends Action {
    payload: IEditSessionPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.sessions.edit

function* editSessionSagaTask({ payload }) {
    try {
        const response = yield axios.patch(`/event/session/${payload.id}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editSessionSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editSessionSagaTask)
}

export default editSessionSaga
